// Orders
import { OrderBrandForm } from "./forms/orders/OrderBrandForm";
import { OrderCityForm } from "./forms/orders/OrderCityForm";
import { OrderClimaticFeatureForm } from "./forms/orders/OrderClimaticFeatureForm";
import { OrderCountryForm } from "./forms/orders/OrderCountryForm";
import { OrderDateAndHourForm } from "./forms/orders/OrderDateAndHourForm";
import { OrderDayForm } from "./forms/orders/OrderDayForm";
import { OrderDayWeekForm } from "./forms/orders/OrderDayWeekForm";
import { OrderDeliveryFeeForm } from "./forms/orders/OrderDeliveryFeeForm";
import { OrderMoistureForm } from "./forms/orders/OrderMoistureForm";
import { OrderMonthForm } from "./forms/orders/OrderMonthForm";
import { OrderNeighborhoodForm } from "./forms/orders/OrderNeighborhoodForm";
import { OrderOriginSaleForm } from "./forms/orders/OrderOriginSaleForm";
import { OrderSourceDataForm } from "./forms/orders/OrderSourceDataForm";
import { OrderStateForm } from "./forms/orders/OrderStateForm";
import { OrderTemperatureForm } from "./forms/orders/OrderTemperatureForm";
import { OrderThermalSensationForm } from "./forms/orders/OrderThermalSensationForm";
import { OrderUnitForm } from "./forms/orders/OrderUnitForm";
import { OrderValueForm } from "./forms/orders/OrderValueForm";
import { OrderWeekForm } from "./forms/orders/OrderWeekForm";
import { OrderYearForm } from "./forms/orders/OrderYearForm";
// Customers
import { CustomerAverageTicketForm } from "./forms/customers/CustomerAverageTicketForm";
import { CustomerBirthdayForm } from "./forms/customers/CustomerBirthdayForm";
import { CustomerDateAndHourForm } from "./forms/customers/CustomerDateAndHourForm";
import { CustomerDayRegistrationForm } from "./forms/customers/CustomerDayRegistrationForm";
import { CustomerDayWeekRegistrationForm } from "./forms/customers/CustomerDayWeekRegistrationForm";
import { CustomerDaysWithoutConversionForm } from "./forms/customers/CustomerDaysWithoutConversionForm";
import { CustomerDocForm } from "./forms/customers/CustomerDocForm";
import { CustomerEmailForm } from "./forms/customers/CustomerEmailForm";
import { CustomerFrequencyOrdersForm } from "./forms/customers/CustomerFrequencyOrdersForm";
import { CustomerGenderForm } from "./forms/customers/CustomerGenderForm";
import { CustomerHourRegistrationForm } from "./forms/customers/CustomerHourRegistrationForm";
import { CustomerLastAttForm } from "./forms/customers/CustomerLastAttForm";
import { CustomerLastOrderForm } from "./forms/customers/CustomerLastOrderForm";
import { CustomerMarketingForm } from "./forms/customers/CustomerMarketingForm";
import { CustomerMonthRegistrationForm } from "./forms/customers/CustomerMonthRegistrationForm";
import { CustomerNameForm } from "./forms/customers/CustomerNameForm";
import { CustomerPhoneForm } from "./forms/customers/CustomerPhoneForm";
import { CustomerQuantityOrdersForm } from "./forms/customers/CustomerQuantityOrdersForm";
import { CustomerRFVForm } from "./forms/customers/CustomerRFVForm";
import { CustomerTotalSpendForm } from "./forms/customers/CustomerTotalSpendForm";
import { CustomerWeekRegistrationForm } from "./forms/customers/CustomerWeekRegistrationForm";
import { CustomerYearRegistrationForm } from "./forms/customers/CustomerYearRegistrationForm";
// Coupons
import { CouponCodeForm } from "./forms/coupons/CouponCodeForm";
import { CouponDayAndHourForm } from "./forms/coupons/CouponDayAndHourForm";
import { CouponDayForm } from "./forms/coupons/CouponDayForm";
import { CouponDayWeekForm } from "./forms/coupons/CouponDayWeekForm";
import { CouponDaysExpForm } from "./forms/coupons/CouponDaysExpForm";
import { CouponDiscountForm } from "./forms/coupons/CouponDiscountForm";
import { CouponExpDateForm } from "./forms/coupons/CouponExpDateForm";
import { CouponExpDateReminderForm } from "./forms/coupons/CouponExpDateReminderForm";
import { CouponHourForm } from "./forms/coupons/CouponHourForm";
import { CouponMinOrderForm } from "./forms/coupons/CouponMinOrderForm";
import { CouponMonthForm } from "./forms/coupons/CouponMonthForm";
import { CouponTypeForm } from "./forms/coupons/CouponTypeForm";
import { CouponWeekForm } from "./forms/coupons/CouponWeekForm";
import { CouponYearForm } from "./forms/coupons/CouponYearForm";
// Products
import { ProductCategoryForm } from "./forms/products/ProductCategoryForm";
import { ProductDayAndHourForm } from "./forms/products/ProductDayAndHourForm";
import { ProductDayForm } from "./forms/products/ProductDayForm";
import { ProductDayWeekForm } from "./forms/products/ProductDayWeekForm";
import { ProductHourForm } from "./forms/products/ProductHourForm";
import { ProductMonthForm } from "./forms/products/ProductMonthForm";
import { ProductNameForm } from "./forms/products/ProductNameForm";
import { ProductQuantityForm } from "./forms/products/ProductQuantityForm";
import { ProductSKUForm } from "./forms/products/ProductSKUForm";
import { ProductSizeForm } from "./forms/products/ProductSizeForm";
import { ProductValueForm } from "./forms/products/ProductValueForm";
import { ProductWeekForm } from "./forms/products/ProductWeekForm";
import { ProductYearForm } from "./forms/products/ProductYearForm";
import { ProfileClimateForm } from "./forms/profiles/ProfileClimateForm";
import { ProfileMomentDayForm } from "./forms/profiles/ProfileMomentDayForm";
import { ProfileMomentWeekForm } from "./forms/profiles/ProfileMomentWeekForm";
import { ProfileRFVForm } from "./forms/profiles/ProfileRFVForm";
import { ProfileSeasonForm } from "./forms/profiles/ProfileSeasonForm";
import { ProfileTemperatureForm } from "./forms/profiles/ProfileTemperatureForm";
import { CustomerAgeForm } from "./forms/customers/CustomerAgeForm";

export const NodeForms = {
  // Orders
  "o.created_at": OrderDateAndHourForm,
  "o.order_total": OrderValueForm,
  "o.delivery_total": OrderDeliveryFeeForm,
  "o.brand_id": OrderBrandForm,
  "o.unit_id": OrderUnitForm,
  "o.source_id": OrderSourceDataForm,
  "o.order_origin": OrderOriginSaleForm,
  "o.delivery_city": OrderCityForm,
  "o.delivery_state": OrderStateForm,
  "o.delivery_country": OrderCountryForm,
  "o.delivery_region": OrderNeighborhoodForm,
  "w.temperature": OrderTemperatureForm,
  "w.feelslike": OrderThermalSensationForm,
  "w.humidity": OrderMoistureForm,
  "w.condition": OrderClimaticFeatureForm,
  "o.year": OrderYearForm,
  "o.day": OrderDayForm,
  "o.week": OrderWeekForm,
  "o.week_day": OrderDayWeekForm,
  "o.month": OrderMonthForm,

  // Customers
  "c.age": CustomerAgeForm,
  "c.created_at": CustomerDateAndHourForm,
  "c.name": CustomerNameForm,
  "c.email": CustomerEmailForm,
  "c.phone": CustomerPhoneForm,
  "c.doc": CustomerDocForm,
  "c.birthdate": CustomerBirthdayForm,
  CustomerGender: CustomerGenderForm,
  "c.updated_at": CustomerLastAttForm,
  "c.sum_order": CustomerTotalSpendForm,
  "c.quantity": CustomerQuantityOrdersForm,
  "c.rfv_profile": CustomerRFVForm,
  "c.average_order": CustomerAverageTicketForm,
  "c.order_frequency": CustomerFrequencyOrdersForm,
  "c.last_conversion": CustomerLastOrderForm,
  "c.consent": CustomerMarketingForm,
  "c.created_at_hour": CustomerHourRegistrationForm,
  "c.created_at_day": CustomerDayRegistrationForm,
  "c.created_at_week": CustomerWeekRegistrationForm,
  "c.created_at_weekday": CustomerDayWeekRegistrationForm,
  "c.created_at_year": CustomerYearRegistrationForm,
  "c.created_at_month": CustomerMonthRegistrationForm,
  "c.days_without_conversion": CustomerDaysWithoutConversionForm,

  // Coupons
  "cc.used_at": CouponDayAndHourForm,
  "cc.code": CouponCodeForm,
  "cc.type": CouponTypeForm,
  "cc.value": CouponDiscountForm,
  "cc.min_order": CouponMinOrderForm,
  "cc.expires_at_days_diff": CouponDaysExpForm,
  "cc.expires_at": CouponExpDateForm,
  "cc.remind_gain_date": CouponExpDateReminderForm,
  "cc.used_at_hour": CouponHourForm,
  "cc.used_at_day": CouponDayForm,
  "cc.used_at_week": CouponWeekForm,
  "cc.used_at_weekday": CouponDayWeekForm,
  "cc.used_at_month": CouponMonthForm,
  "cc.used_at_year": CouponYearForm,

  // Products
  "p.created_at": ProductDayAndHourForm,
  "p.sku": ProductSKUForm,
  "p.name": ProductNameForm,
  "p.quantity": ProductQuantityForm,
  "p.created_at_hour": ProductHourForm,
  "p.total": ProductValueForm,
  "p.size_name": ProductSizeForm,
  "p.category_name": ProductCategoryForm,
  "p.created_at_year": ProductYearForm,
  "p.created_at_month": ProductMonthForm,
  "p.created_at_day": ProductDayForm,
  "p.created_at_week": ProductWeekForm,
  "p.created_at_weekday": ProductDayWeekForm,

  "pp.rfv": ProfileRFVForm,
  "pp.climate": ProfileClimateForm,
  "pp.moment_week": ProfileMomentWeekForm,
  "pp.moment_day": ProfileMomentDayForm,
  "pp.season": ProfileSeasonForm,
  "pp.temperature": ProfileTemperatureForm,
};
